"use strict";

var _objectSpread = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");
var _objectWithoutProperties = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectWithoutProperties");
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Size = void 0;
var _react = _interopRequireDefault(require("react"));
var DialogPrimitive = _interopRequireWildcard(require("@radix-ui/react-dialog"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _tokens = _interopRequireDefault(require("../../../shared/tokens/tokens"));
var _Icon = require("../../media/icon/Icon");
var _modal = require("./modal.tokens");
var _flex = require("../../layout/flex");
var _Button = _interopRequireWildcard(require("../../controls/buttons/Button"));
var _FlexItem = require("../../layout/flex/FlexItem");
var _Tooltip = _interopRequireDefault(require("../tooltip/Tooltip"));
var _jsxRuntime = require("react/jsx-runtime");
var Size = exports.Size = /*#__PURE__*/function (Size) {
  Size["EXTRA_SMALL"] = "xs";
  Size["SMALL"] = "s";
  Size["MEDIUM"] = "m";
  Size["LARGE"] = "l";
  Size["EXTRA_LARGE"] = "xl";
  Size["EXTRA_EXTRA_LARGE"] = "xxl";
  return Size;
}({}); // Do not use without the review of breakpoints for screens smaller than 1158 with the designer
;
var StyledOverlay = (0, _styledComponents.default)(DialogPrimitive.Overlay).withConfig({
  displayName: "Modal__StyledOverlay",
  componentId: "sc-189shs-0"
})(["inset:0;position:fixed;display:flex;justify-content:center;align-items:center;background-color:", "66;z-index:1000;"], _globalTokens.globalColor.background.neutral['3']);
var StyledContent = (0, _styledComponents.default)(DialogPrimitive.Content).withConfig({
  displayName: "Modal__StyledContent",
  componentId: "sc-189shs-1"
})(["position:absolute;display:flex;flex-direction:column;background:", ";padding:", " 0;", ";width:", ";max-width:80vw;border-radius:", ";gap:", ";align-items:stretch;", ";"], _globalTokens.globalColor.background.neutral['1'], _globalTokens.globalSpacing['600'], _globalTokens.globalShadow.modals, function (_ref) {
  var $size = _ref.$size;
  return _modal.tokens.size[$size].width;
}, _globalTokens.globalBorder.radius['5'], _globalTokens.globalSpacing['600'], _tokens.default.sky.sys.font.body['1']);
var ModalTitle = (0, _styledComponents.default)(DialogPrimitive.Title).withConfig({
  displayName: "Modal__ModalTitle",
  componentId: "sc-189shs-2"
})(["margin:0;", ";padding:0 ", ";"], _tokens.default.sky.sys.font.heading['3'], _globalTokens.globalSpacing['600']);
var IconPosition = _styledComponents.default.button.withConfig({
  displayName: "Modal__IconPosition",
  componentId: "sc-189shs-3"
})(["display:inline-flex;position:absolute;align-items:center;justify-content:center;top:", ";right:", ";background:transparent;border:0;cursor:pointer;outline:none;"], _globalTokens.globalSpacing['600'], _globalTokens.globalSpacing['600']);
var StyledFooter = _styledComponents.default.div.withConfig({
  displayName: "Modal__StyledFooter",
  componentId: "sc-189shs-4"
})(["display:flex;gap:", ";padding-top:", ";padding:0 ", ";"], _globalTokens.globalSpacing['100'], _globalTokens.globalSpacing['200'], _globalTokens.globalSpacing['600']);
var ModalContent = _styledComponents.default.div.withConfig({
  displayName: "Modal__ModalContent",
  componentId: "sc-189shs-5"
})(["display:flex;flex-direction:column;gap:", ";padding:0 ", ";max-height:calc(100vh - 300px);min-height:", ";overflow-y:auto;"], _globalTokens.globalSpacing['400'], _globalTokens.globalSpacing['600'], _globalTokens.globalSizing['2400']);
var wrapTooltip = function wrapTooltip(props, button) {
  if (props.tooltipContent) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.default, {
      content: props.tooltipContent,
      children: button
    });
  } else {
    return button;
  }
};
var PrimaryFooterButton = function PrimaryFooterButton(_ref2) {
  var children = _ref2.children,
    dataCy = _ref2.dataCy,
    rest = _objectWithoutProperties(_ref2, ["children", "dataCy"]);
  return wrapTooltip(rest, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, _objectSpread({}, rest, {
    "data-cy": dataCy,
    children: children
  })));
};
var SecondaryFooterButton = function SecondaryFooterButton(_ref3) {
  var children = _ref3.children,
    dataCy = _ref3.dataCy,
    rest = _objectWithoutProperties(_ref3, ["children", "dataCy"]);
  return wrapTooltip(rest, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, _objectSpread({}, rest, {
    "data-cy": dataCy,
    emphasis: _Button.EMPHASIS.MEDIUM,
    children: children
  })));
};
var TertiaryFooterButton = function TertiaryFooterButton(_ref4) {
  var children = _ref4.children,
    dataCy = _ref4.dataCy,
    rest = _objectWithoutProperties(_ref4, ["children", "dataCy"]);
  return wrapTooltip(rest, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, _objectSpread({}, rest, {
    "data-cy": dataCy,
    emphasis: _Button.EMPHASIS.LOW,
    children: children
  })));
};
var ModalFooter = function ModalFooter(_ref5) {
  var children = _ref5.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledFooter, {
    children: _react.default.Children.map(children, function (child) {
      var _child$type;
      var childType = child === null || child === void 0 ? void 0 : (_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name;
      if (childType === PrimaryFooterButton.name) {
        return child;
      } else if (childType === SecondaryFooterButton.name) {
        return child;
      } else if (childType === TertiaryFooterButton.name) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FlexItem.FlexItem, {
          flexGrow: '1',
          alignSelf: _flex.FLEX_ALIGN_ITEMS.END,
          justifyContent: _flex.FLEX_ALIGN_ITEMS.END,
          children: child
        });
      } else if (childType) {
        throw new Error('Footer can only take PrimaryFooterButton, SecondaryFooterButton or TertiaryFooterButton as children');
      }
    })
  });
};
var Modal = function Modal(_ref6) {
  var _ref6$size = _ref6.size,
    size = _ref6$size === void 0 ? Size.MEDIUM : _ref6$size,
    children = _ref6.children,
    trigger = _ref6.trigger,
    onCloseModal = _ref6.onCloseModal;
  var hasTrigger = !!trigger;
  var onOpenChange = function onOpenChange(open) {
    if (!open && onCloseModal) {
      onCloseModal();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(DialogPrimitive.Root, {
    defaultOpen: !hasTrigger,
    onOpenChange: onOpenChange,
    children: [hasTrigger && /*#__PURE__*/(0, _jsxRuntime.jsx)(DialogPrimitive.Trigger, {
      asChild: true,
      children: trigger
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(DialogPrimitive.Portal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledOverlay, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledContent, {
          $size: size,
          children: [children, /*#__PURE__*/(0, _jsxRuntime.jsx)(DialogPrimitive.Close, {
            asChild: true,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(IconPosition, {
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                icon: 'close',
                size: 'l'
              })
            })
          })]
        })
      })
    })]
  });
};
Modal.SIZE = Size;
Modal.Title = ModalTitle;
Modal.Content = ModalContent;
Modal.Footer = ModalFooter;
Modal.PrimaryFooterButton = PrimaryFooterButton;
Modal.SecondaryFooterButton = SecondaryFooterButton;
Modal.TertiaryFooterButton = TertiaryFooterButton;
var _default = exports.default = Modal;